import { validate } from 'rut.js';
import { mixed, object, type ObjectSchema, string } from 'yup';

import { isDniRegisteredFeatureEnabled } from '@/config/featureFlags';
import {
  type IdentificationDocumentType,
  IdentificationDocumentTypes
} from '@/modules/shared/types/IdentificationDocumentType';
import type { PickupPersonFormValues } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/PickupPerson/interfaces';

const COMPLETE_NAME_MAX_LENGTH = 65;
export const RUT_MIN_LENGTH = 11;
export const RUT_MAX_LENGTH = 12;
export const DNI_MIN_LENGTH = 8;
export const DNI_MAX_LENGTH = 18;

const dniEnabled = isDniRegisteredFeatureEnabled();

export const pickupPersonValidator: ObjectSchema<PickupPersonFormValues> =
  object().shape({
    completeName: string()
      .required('Campo obligatorio.')
      .max(COMPLETE_NAME_MAX_LENGTH, 'Has llegado al máximo de caracteres.'),

    pickupPersonRut: string().when('documentType', {
      is: (val: string) => !dniEnabled || !val,
      then: (schema) =>
        schema
          .required('Campo obligatorio.')
          .min(RUT_MIN_LENGTH, 'El RUT ingresado no es válido.')
          .max(RUT_MAX_LENGTH, 'El RUT ingresado no es válido.')
          .test('is-rut-valid', 'El RUT ingresado no es válido.', validate),
      otherwise: (schema) => schema.notRequired()
    }),

    documentType: mixed<IdentificationDocumentType>().when([], {
      is: () => dniEnabled,
      then: (schema) =>
        schema
          .required('Campo obligatorio.')
          .oneOf(
            [IdentificationDocumentTypes.RUT, IdentificationDocumentTypes.DNI],
            'Tipo de documento inválido'
          ),
      otherwise: (schema) => schema.notRequired()
    }),

    documentID: string().when('documentType', {
      is: IdentificationDocumentTypes.RUT,
      then: (schema) =>
        dniEnabled
          ? schema
              .required('Campo obligatorio.')
              .min(RUT_MIN_LENGTH, 'El RUT ingresado no es válido.')
              .max(RUT_MAX_LENGTH, 'El RUT ingresado no es válido.')
              .test('is-rut-valid', 'El RUT ingresado no es válido.', validate)
          : schema.notRequired(),
      otherwise: (schema) =>
        schema.when('documentType', {
          is: IdentificationDocumentTypes.DNI,
          then: (schema) =>
            dniEnabled
              ? schema
                  .required('Campo obligatorio.')
                  .min(DNI_MIN_LENGTH, 'Por favor, ingresa un DNI válido.')
                  .max(DNI_MAX_LENGTH, 'Por favor, ingresa un DNI válido.')
                  .matches(/^[A-Z0-9]+$/i, 'Por favor, ingresa un DNI válido.')
              : schema.notRequired(),
          otherwise: (schema) => schema.notRequired()
        })
    })
  });

export default pickupPersonValidator;
